<template>
  <div
    class="home"
    ref="pchome"
    :style="{
      '--custom-bg-height': `${logoList[1]?.remark || 0}px`,
    }"
  >
    <!-- 批量上传弹窗 -->
    <van-popup
      v-model="showImportDialog"
      round
      position="center"
      style="width: 500px; margin: 0 auto"
    >
      <div class="popup-content" style="padding: 20px">
        <!-- 批量上传供需信息 -->
        <h3 style="text-align: center; margin: 0 0 20px 0">
          {{ $t("pcHome.bulkUploadTitle") }}
        </h3>
        <van-uploader
          :after-read="handleFileUpload"
          :before-delete="beforeDeleteFile"
          v-model="importFileList"
          multiple
          :max-count="1"
          accept=".xlsx,.xls"
          style="margin-bottom: 20px"
        >
          <svg width="50" height="50" viewBox="0 0 48 48" fill="#999">
            <path
              d="M28 16H12v14h4V22h12v8h4V16zM12 8v4h24V8h-4l-4 4H16l-4-4H12z"
            ></path>
            <path
              d="M40 44H8c-2.2 0-4-1.8-4-4V8c0-2.2 1.8-4 4-4h32c2.2 0 4 1.8 4 4v32c0 2.2-1.8 4-4 4zM8 8v32h32V8H8z"
            ></path>
          </svg>
        </van-uploader>
        <div style="display: flex; justify-content: space-between">
          <!-- 取消 -->
          <van-button @click="handleCancel">{{
            $t("pcHome.cancel")
          }}</van-button>
          <!-- 确定 -->
          <van-button type="primary" @click="submitImport">{{
            $t("pcHome.confirm")
          }}</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 背景图 -->
    <img class="home-bg" :src="logoList[1].image" />

    <div class="main-container" id="pc-home-main">
      <!-- 四个根本 -->
      <div
        class="flex_ac c837d w100 ju_sp_between font18"
        style="margin: 10px 0 60px 0"
      >
        <div class="flex_ac">
          <img
            :src="require('@/img/home/1.png')"
            width="18px"
            height="18px"
            style="margin-right: 13px"
          />
          <!-- 卓越服务 -->
          <div>{{ $t("pcHome.excellentService") }}</div>
        </div>
        <div class="flex_ac">
          <img
            :src="require('@/img/home/2.png')"
            width="18px"
            height="18px"
            style="margin-right: 13px"
          />
          <!-- 持续创造 -->
          <div>{{ $t("pcHome.continuousInnovation") }}</div>
        </div>
        <div class="flex_ac">
          <img
            :src="require('@/img/home/3.png')"
            width="18px"
            height="18px"
            style="margin-right: 13px"
          />
          <!-- 协作共赢 -->
          <div>{{ $t("pcHome.winWinCooperation") }}</div>
        </div>
        <div class="flex_ac">
          <img
            :src="require('@/img/home/4.png')"
            width="18px"
            height="18px"
            style="margin-right: 13px"
          />
          <!-- 价值共享 -->
          <div>{{ $t("pcHome.sharedValue") }}</div>
        </div>
      </div>

      <!-- 快捷入口 -->
      <div v-if="navList && navList.length > 0" class="shortcut-wrapper">
        <!-- 左右滚动按钮 -->
        <button class="scroll-btn left-btn" @click="scrollLeft">&lt;</button>

        <!-- 滚动容器 -->
        <div class="scroll-container">
          <!-- <div class="grid-title">快捷入口</div> -->
          <!-- 实际滚动的内容容器 -->
          <div class="grid-outer">
            <div
              ref="scrollContainer2"
              class="grid-container"
              :style="carouselStyle"
            >
              <!-- 前置复制项 -->
              <div
                v-for="(item, index) in navList"
                :key="'prev-' + item.imgUrl + '-' + index"
                class="grid-item"
                @click="onJump(item)"
              >
                <div class="icon-wrapper">
                  <!-- 图标 -->
                  <img
                    :src="item.imgUrl"
                    :alt="$t('pcHome.shortcutIcon')"
                    class="grid-icon"
                  />
                </div>
                <div class="grid-text">{{ item.text }}</div>
              </div>
              <!-- 原始数据 -->
              <div
                v-for="(item, index) in navList"
                :key="item.imgUrl + '-' + index"
                class="grid-item"
                @click="onJump(item)"
              >
                <div class="icon-wrapper">
                  <!-- 图标 -->
                  <img
                    :src="item.imgUrl"
                    :alt="$t('pcHome.shortcutIcon')"
                    class="grid-icon"
                  />
                </div>
                <div class="grid-text">{{ item.text }}</div>
              </div>
              <!-- 后置复制项 -->
              <div
                v-for="(item, index) in navList"
                :key="'next-' + item.imgUrl + '-' + index"
                class="grid-item"
                @click="onJump(item)"
              >
                <div class="icon-wrapper">
                  <!-- 图标 -->
                  <img
                    :src="item.imgUrl"
                    :alt="$t('pcHome.shortcutIcon')"
                    class="grid-icon"
                  />
                </div>
                <div class="grid-text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>

        <button class="scroll-btn right-btn" @click="scrollRight">&gt;</button>
      </div>

      <!-- 商品与信息 -->
      <div class="tab-container">
        <div class="tab-header">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            :class="['tab-item', { active: activeTab === index }]"
            @click="activeTab = index"
          >
            {{ tab.title }}
          </div>
        </div>
        <div class="tab-content">
          <!-- 商品标签页 -->
          <div v-if="activeTab === 0">
            <!-- 视图切换 -->
            <div
              style="
                margin-bottom: 20px;
                display: flex;
                justify-content: flex-end;
                align-items: center;
              "
            >
              <el-radio-group v-model="viewMode" size="small">
                <!-- 图片视图 -->
                <el-radio-button label="grid">{{
                  $t("pcCsHome.imageView")
                }}</el-radio-button>
                <!-- 表格视图 -->
                <el-radio-button label="table">{{
                  $t("pcCsHome.tableView")
                }}</el-radio-button>
              </el-radio-group>
            </div>

            <!-- 我们是有底线的 -->
            <!-- 获取数据失败，请重新加载 -->
            <van-list
              v-model="loading"
              :finished="finished"
              :finished-text="$t('pcHome.endOfList')"
              :error-text="$t('pcHome.loadFailedRetry')"
              @load="onLoad"
            >
              <!-- 图片视图 -->
              <div v-if="viewMode === 'grid'" class="goods-list-pc">
                <GoodsItem
                  v-for="(item, index) in list"
                  :key="index"
                  :item="item"
                  @click="onJump(item)"
                ></GoodsItem>
              </div>

              <!-- 表格视图 -->
              <el-table
                v-else
                :data="list"
                style="width: 100%; margin-bottom: 20px"
              >
                <!-- 图片 -->
                <el-table-column
                  prop="goodsImage"
                  :label="$t('pcHome.image')"
                  min-width="100"
                >
                  <template #default="{ row }">
                    <img
                      :src="row.goodsImage"
                      :alt="$t('pcHome.productImage')"
                      style="
                        width: 60px;
                        height: 60px;
                        object-fit: cover;
                        cursor: pointer;
                      "
                      @click="onJump(row)"
                    />
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="goodsName" label="商品名称" min-width="200" /> -->
                <!-- 品牌 -->
                <el-table-column
                  prop="goodsBrand"
                  :label="$t('pcHome.brand')"
                  min-width="80"
                />
                <!-- 料号 -->
                <el-table-column
                  prop="goodsNum"
                  :label="$t('pcHome.partNumber')"
                  min-width="200"
                />
                <!-- 类型 -->
                <el-table-column
                  prop="productType"
                  :label="$t('pcHome.type')"
                  min-width="80"
                />
                <!-- 容量 -->
                <el-table-column
                  prop="capacity"
                  :label="$t('pcHome.capacity')"
                  min-width="80"
                />
                <!-- 架构 -->
                <el-table-column
                  prop="architecture"
                  :label="$t('pcHome.architecture')"
                  min-width="80"
                />
                <!-- 速率 -->
                <el-table-column
                  prop="speed"
                  :label="$t('pcHome.speed')"
                  min-width="100"
                />
                <!-- 球位 -->
                <el-table-column
                  prop="ball"
                  :label="$t('pcHome.ballCount')"
                  min-width="80"
                />
                <el-table-column
                  prop="manufactureDate"
                  label="DC"
                  min-width="80"
                />
                <!-- 价格 -->
                <el-table-column
                  prop="salePrice"
                  :label="$t('pcHome.price')"
                  min-width="120"
                >
                  <template #default="{ row }">
                    {{ $formatPrice(row.salePrice) }}
                    {{
                      row.priceUnit === 0
                        ? "CNY"
                        : row.priceUnit === 10
                          ? "USD"
                          : $t("auth.sentenceSeparator")
                    }}
                  </template>
                </el-table-column>
                <!-- 数量 -->
                <el-table-column
                  prop="goodsQuantity"
                  :label="$t('pcHome.quantity')"
                  min-width="100"
                >
                  <template #default="{ row }">
                    {{ row.quantity }} {{ row.goodsUnit || $t("auth.sentenceSeparator") }}
                  </template>
                </el-table-column>
                <!-- 发布人 -->
                <el-table-column
                  prop="shopContacts"
                  :label="$t('pcHome.publisher')"
                  min-width="150"
                />
              </el-table>

              <!-- 暂无数据 -->
              <el-empty
                v-if="list && list.length <= 0"
                :description="$t('pcHome.noData')"
              />
            </van-list>
          </div>
          <!-- 信息标签页 -->
          <div v-if="activeTab === 1">
            <!-- 筛选条件 -->
            <div
              style="
                margin-bottom: 20px;
                padding: 15px;
                background: #f5f7fa;
                border-radius: 4px;
              "
            >
              <div style="margin-bottom: 15px; text-align: right">
                <!-- 导入供需 -->
                <el-button type="warning" @click="showImportDialog = true">{{
                  $t("pcHome.importSupplyDemand")
                }}</el-button>
              </div>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div style="margin-bottom: 10px">
                    <!-- 品牌 -->
                    <label
                      style="
                        display: inline-block;
                        width: 60px;
                        font-weight: 500;
                      "
                      >{{ $t("pcHome.brand") }}</label
                    >
                    <!-- 请输入品牌 -->
                    <el-input
                      v-model="infoFilters.brand"
                      :placeholder="$t('pcCsHome.brandPlaceholder')"
                      style="width: calc(100% - 70px)"
                    />
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="margin-bottom: 10px">
                    <!-- 料号 -->
                    <label
                      style="
                        display: inline-block;
                        width: 60px;
                        font-weight: 500;
                      "
                      >{{ $t("pcHome.partNumber") }}</label
                    >
                    <!-- 请输入料号 -->
                    <el-input
                      v-model="infoFilters.model"
                      :placeholder="$t('pcCsHome.partNumberPlaceholder')"
                      style="width: calc(100% - 70px)"
                    />
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="margin-bottom: 10px">
                    <!-- 货源地 -->
                    <label
                      style="
                        display: inline-block;
                        width: 60px;
                        font-weight: 500;
                      "
                      >{{ $t("pcCsHome.origin") }}</label
                    >
                    <!-- 请选择货源地 -->
                    <el-select
                      v-model="infoFilters.type"
                      :placeholder="$t('pcCsHome.originPlaceholder')"
                      style="width: calc(100% - 70px)"
                    >
                      <!-- 大陆 -->
                      <el-option :label="$t('pcHome.mainland')" value="1" />
                      <!-- 港澳台 -->
                      <el-option
                        :label="$t('pcHome.hongKongMacaoTaiwan')"
                        value="2"
                      />
                    </el-select>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="margin-bottom: 10px">
                    <!-- 供应商 -->
                    <label
                      style="
                        display: inline-block;
                        width: 60px;
                        font-weight: 500;
                      "
                      >{{ $t("pcHome.supplier") }}</label
                    >
                    <!-- 请输入供应商 -->
                    <el-input
                      v-model="infoFilters.supplier"
                      :placeholder="$t('pcCsHome.supplierPlaceholder')"
                      style="width: calc(100% - 70px)"
                    />
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="7">
                  <div style="margin-bottom: 10px">
                    <!-- 产品类型 -->
                    <label
                      style="
                        display: inline-block;
                        width: 70px;
                        font-weight: 500;
                      "
                      >{{ $t("pcCsHome.productType") }}</label
                    >
                    <!-- 请输入产品类型/容量/架构/速率/球位 -->
                    <el-input
                      v-model="infoFilters.productType"
                      :placeholder="$t('pcCsHome.productTypePlaceholder')"
                      style="width: calc(100% - 70px)"
                    />
                  </div>
                </el-col>
                <el-col :span="12">&nbsp;</el-col>
                <el-col :span="5">
                  <div style="text-align: right">
                    <!-- 重置 -->
                    <el-button
                      type="default"
                      @click="resetFilters"
                      style="margin-right: 10px"
                      >{{ $t("pcHome.reset") }}</el-button
                    >
                    <!-- 查询 -->
                    <el-button type="primary" @click="sekectList">{{
                      $t("pcHome.query")
                    }}</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- 表格内容区域 -->
            <div>
              <!-- 加载中... -->
              <div
                v-if="infoLoading && infoList.length === 0"
                class="loading-container"
                v-loading="infoLoading"
                :element-loading-text="$t('pcHome.loading')"
                style="
                  height: 300px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              ></div>
              <div
                v-else-if="infoError"
                class="error-container"
                style="
                  height: 300px;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                "
              >
                <!-- 获取数据失败，请刷新重试 -->
                <el-empty :description="$t('pcHome.loadFailedRefresh')" />
                <!-- 重新加载 -->
                <el-button
                  type="primary"
                  size="small"
                  @click="getInfoList"
                  style="margin-top: 20px"
                >
                  {{ $t("pcHome.reload") }}
                </el-button>
              </div>
              <!-- 我们是有底线的 -->
              <!-- 获取数据失败，请重新加载 -->
              <van-list
                v-else
                v-model:loading="infoLoading"
                :finished="infoFinished"
                :finished-text="$t('pcHome.endOfList')"
                :error-text="$t('pcHome.loadFailedRetry')"
                @load="loadMoreInfo"
                style="max-height: none"
              >
                <el-table
                  :data="infoList"
                  style="width: 100%; cursor: pointer"
                  @row-click="handleRowClick"
                >
                  <el-table-column width="55">
                    <template #default="{ row }">
                      <div @click.stop>
                        <el-checkbox
                          :disabled="
                            row.supplierId !== 1 && row.supplierId !== 2
                          "
                          v-model="row.selected"
                          @change="handleCustomSelect(row)"
                        ></el-checkbox>
                      </div>
                    </template>
                  </el-table-column>
                  <!-- 品牌 -->
                  <el-table-column
                    prop="goodsBrand"
                    :label="$t('pcHome.brand')"
                    min-width="80"
                  />
                  <!-- 料号 -->
                  <el-table-column
                    prop="partNumber"
                    :label="$t('pcHome.partNumber')"
                    min-width="180"
                  />
                  <!-- 类型 -->
                  <el-table-column
                    prop="productType"
                    :label="$t('pcHome.type')"
                    min-width="80"
                  />
                  <!-- 容量 -->
                  <el-table-column
                    prop="capacity"
                    :label="$t('pcHome.capacity')"
                    min-width="80"
                  />
                  <!-- 架构 -->
                  <el-table-column
                    prop="architecture"
                    :label="$t('pcHome.architecture')"
                    min-width="80"
                  />
                  <!-- 速率 -->
                  <el-table-column
                    prop="speed"
                    :label="$t('pcHome.speed')"
                    min-width="100"
                  />
                  <!-- 球位 -->
                  <el-table-column
                    prop="ball"
                    :label="$t('pcHome.ballCount')"
                    min-width="80"
                  />
                  <!-- 单价 -->
                  <el-table-column
                    prop="price"
                    :label="$t('pcHome.unitPrice')"
                    min-width="110"
                  />
                  <!-- 数量 -->
                  <el-table-column
                    prop="goodsQuantity"
                    :label="$t('pcHome.quantity')"
                    min-width="70"
                  />
                  <!-- 批次 -->
                  <el-table-column
                    prop="manufactureDate"
                    :label="$t('pcHome.batch')"
                    min-width="60"
                  />
                  <!-- 货所在地 -->
                  <el-table-column
                    prop="deliveryAddress"
                    :label="$t('pcHome.goodsLocation')"
                    min-width="60"
                  />
                  <!-- 发布时间 -->
                  <el-table-column
                    prop="createTime"
                    :label="$t('pcHome.publishedAt')"
                    min-width="100"
                  >
                    <template #default="{ row }">
                      {{ row.createTime || $t("auth.sentenceSeparator") }}
                    </template>
                  </el-table-column>
                  <!-- 供应商 -->
                  <el-table-column
                    prop="supplierName"
                    :label="$t('pcHome.supplier')"
                    min-width="120"
                  />
                </el-table>
              </van-list>
            </div>
          </div>
          <!-- 选中项操作弹窗 -->
          <div
            v-if="selectedInfoItems.length > 0"
            style="
              position: fixed;
              bottom: 20px;
              left: 50%;
              transform: translateX(-50%);
              background: #fff;
              border: 1px solid #e0e0e0;
              border-radius: 8px;
              padding: 15px 20px;
              box-shadow: 0 2px 15px rgba(0, 0, 0, 0.15);
              z-index: 1000;
              display: flex;
              justify-content: space-between;
              align-items: center;
              min-width: 300px;
              max-width: 400px;
              width: 60%;
            "
          >
            <!-- 已选择 {count} 项 -->
            <div>
              {{
                $t("pcHome.selectedCount", { count: selectedInfoItems.length })
              }}
            </div>
            <div>
              <!-- 删除 -->
              <el-button
                type="danger"
                size="medium"
                style="margin-right: 10px"
                @click="handleDeleteSelected"
                >{{ $t("pcHome.delete") }}</el-button
              >
              <!-- 审核 -->
              <el-button
                v-if="isAudit"
                type="success"
                size="medium"
                @click="handleAuditSelected"
                >{{ $t("pcHome.review") }}</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <PcFooter />
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import GoodsItem from "@/components/pc/GoodsItem.vue";
import PcFooter from "@/components/pc/PcFooter.vue";
import {
  getHomeNav,
  getGoods,
  getBannerAdv,
  getHomeData,
  getHomeClue,
} from "@/api/home";
import { getUserInfoDetail } from "@/api/user.js";
import { listPendingClue, swPendingFollowList } from "@/api/bizOppor";
import { updateFile } from "@/api/upload";
import { importClue, auditClue, deleteClue } from "@/api/clue";
import { Message } from "element-ui";
export default {
  name: "CshHome",
  components: {
    GoodsItem,
    PcFooter,
  },
  data() {
    return {
      carouselOffset: 0, // 轮播偏移量（负数表示向左移动）
      itemWidth: 194, // 每个item的宽度（170+24含间距，根据实际调整）
      currentIndex: 0, // 当前显示的中心索引
      isTransitioning: false, // 是否正在过渡动画中
      bannerList: [], //轮播
      logoList: [{}, {}], //logo图--要初始化因为我上面直接用了
      navList: [], //导航
      proList: [], //商品
      advImg: null,
      params: {
        pageSize: 20,
        pageNum: 0,
        pageNum: 1,
        which: 1,
        position: "HOME",
        status: 0,
        goodsType: null,
      },
      tabList: [
        { title: "供应", type: 1 },
        { title: "求购", type: 2 },
      ],
      list: [],
      active: 0,
      serachShow: false, //搜索查询状态刷新状态
      checkMore: true,
      refreshing: false, //刷新状态默认值
      loading: false,
      finished: false,
      error: false,
      hasNewClue: null, //是否有新订单
      userBusinessType: null, // 用户业务类型
      activeTab: 0,
      // 视图模式：grid(图片视图) 或 table(表格视图)
      viewMode: "grid",
      // 信息列表数据
      infoList: [],
      // 信息列表加载状态
      infoLoading: false,
      // 信息列表错误状态
      infoError: false,
      // 信息列表是否加载完成
      infoFinished: false,
      // 信息列表筛选条件
      infoFilters: {
        brand: "",
        model: "",
        type: "",
        supplier: "",
        pageNum: 1,
        pageSize: 10,
      },
      // 选中的信息列表项
      selectedInfoItems: [],
      // 批量上传相关
      showImportDialog: false,
      importFileList: [],
      isAudit: false,
    };
  },
  computed: {
    // ...mapState({
    //   userInfo: (state) => state.user.userDetails,
    // }),
    // 轮播样式
    carouselStyle() {
      return {
        transform: `translateX(${this.carouselOffset}px)`,
        transition: this.isTransitioning ? "transform 0.3s ease" : "none",
      };
    },
    uiLocale() {
      return this.$store.state.locale.uiLocale;
    },
    // 标签页数据，根据用户角色动态显示
    tabs() {
      // 商品
      const baseTabs = [{ title: this.$t("pcCsHome.products") }];
      // 只有businessType == 10时才显示信息标签页
      if (this.userBusinessType == 10) {
        // 信息
        baseTabs.push({ title: this.$t("pcCsHome.information") });
      }
      return baseTabs;
    },
  },
  watch: {
    uiLocale() {
      const statusKeys = {
        uploading: "pcHome.uploading",
        success: "pcHome.uploadSuccess",
        failed: "pcHome.uploadFailed",
      };
      this.importFileList.forEach((file) => {
        if (statusKeys[file.status]) {
          // 动态简中候选：由 statusKeys[file.status] 的本文件映射／赋值选择，保留原状态和键
          // pcHome.uploading：上传中...
          // pcHome.uploadSuccess：上传成功
          // pcHome.uploadFailed：上传失败
          this.$set(file, "message", this.$t(statusKeys[file.status]));
        }
      });
    },
  },
  mounted() {
    // 初始化轮播位置
    this.initCarousel();
    // 监听窗口变化时重新获取
    window.addEventListener("resize", this.initCarousel);
  },
  updated() {
    // 数据更新导致 DOM 变化后重新初始化（比如 navList 变化）
    if (this.navList.length > 0 && this.currentIndex === 0) {
      this.initCarousel();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.initCarousel);
  },
  methods: {
    // 初始化轮播位置
    initCarousel() {
      const totalItems = this.navList.length;
      if (totalItems > 0) {
        // 初始位置设置为原始数据组的起始位置（索引为totalItems）
        this.currentIndex = totalItems;
        this.carouselOffset = -this.currentIndex * this.itemWidth;
      }
    },
    // 处理商品搜索（子组件触发的事件）
    onProductSearch(value) {
      console.log("父组件接收商品搜索值：", value);
      // 这里写商品搜索的业务逻辑
      // 例如：调用接口 this.$api.searchProduct(value)
    },
    isLogin() {
      return this.$store.getters.token;
    },
    async getUserInfoDetail() {
      const response = await getUserInfoDetail();
      if (response.code === 200) {
        const { businessType } = response.data.userInfo;
        this.userBusinessType = businessType; // 保存用户业务类型
        // 设置默认视图模式：谈判人默认表格视图，其他默认图片视图
        this.viewMode = businessType == 10 ? "table" : "grid";
        // 谈判人角色|| 商务角色
        if (businessType == 10 || businessType == 20) {
          this.needShowTip(businessType);
        }
        // 如果是谈判人，获取信息列表
        if (businessType == 10) {
          this.getInfoList();
        }
      }
    },
    async needShowTip(type) {
      // 确保类型一致，避免 switch (===) 匹配失败
      let businessType = Number(type);
      switch (businessType) {
        case 10:
          // 谈判人-新订单列表
          this.hasNewClue = await listPendingClue();
          break;
        case 20:
          // 商务-新订单列表
          this.hasNewClue = await swPendingFollowList();
          break;
      }
      if (this.hasNewClue.rows && this.hasNewClue.rows.length) {
        // 把已经提醒过的状态保存起来，下次进来就不提醒了
        sessionStorage.setItem("hasTip", 1);
        const path =
          businessType == 10
            ? "/follow/pendingFollow"
            : "/follow/swPendingFollow";
        Dialog.confirm({
          // 您有新订单!
          title: this.$t("pcHome.newOrders"),
          // 去接单
          confirmButtonText: this.$t("pcHome.acceptOrder"),
          confirmButtonColor: "#4689F2",
        })
          .then(() => {
            this.$router.push({
              path,
            });
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    // 向左滚动
    scrollLeft() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex--;
      this.carouselOffset = -this.currentIndex * this.itemWidth;

      // 检查是否需要无缝重置
      setTimeout(() => {
        const totalItems = this.navList.length;
        // 如果滚动到前置复制区域（索引 < totalItems - 1）
        if (this.currentIndex < totalItems - 1) {
          this.isTransitioning = false;
          // 关闭动画，瞬间跳转到后置复制组的对应位置
          // 保持相对位置：前置第0个 -> 后置倒数第2个
          const offset = totalItems - 1 - this.currentIndex;
          this.currentIndex = totalItems * 2 - 1 - offset;
          this.carouselOffset = -this.currentIndex * this.itemWidth;
        }
        this.isTransitioning = false;
      }, 300);
    },
    // 向右滚动
    scrollRight() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.currentIndex++;
      this.carouselOffset = -this.currentIndex * this.itemWidth;

      // 检查是否需要无缝重置
      setTimeout(() => {
        const totalItems = this.navList.length;
        // 如果滚动到后置复制区域末尾（索引 >= totalItems * 2）
        if (this.currentIndex >= totalItems * 2) {
          this.isTransitioning = false;
          // 关闭动画，瞬间跳转到原始数据的对应位置
          // 保持相对位置：后置第2*totalItems个 -> 原始第totalItems个
          const offset = this.currentIndex - totalItems * 2;
          this.currentIndex = totalItems + offset;
          this.carouselOffset = -this.currentIndex * this.itemWidth;
        }
        this.isTransitioning = false;
      }, 300);
    },
    onJump(item) {
      if (item.path) {
        if (item.text == "供应" || item.text == "需求") {
          this.$router.push({
            path: item.path,
            query: { active: item.text == "供应" ? 0 : 1 },
          });
        } else {
          this.$router.push(item.path);
        }
      } else if (item.goodsCode) {
        this.$router.push(`/prodetail/${item.goodsCode}`);
      }
    },
    // 处理表格行点击事件
    handleRowClick(row) {
      // 跳转到货源详情页面，带着id
      this.$router.push({
        path: "/clue/clueDetail",
        query: { id: row.id },
      });
    },
    // 处理品牌栏点击事件
    handleBrandClick(row) {
      // 阻止事件冒泡，不让品牌栏触发行点击事件
      console.log("品牌栏被点击:", row.goodsBrand);
    },
    // 重置筛选条件
    resetFilters() {
      this.infoFilters = {
        brand: "",
        model: "",
        type: "",
        supplier: "",
        pageNum: 1,
        pageSize: 10,
      };
      this.infoList = [];
      this.getInfoList();
    },
    sekectList() {
      this.infoList = [];
      this.infoFilters.pageNum = 1;
      this.getInfoList();
    },
    // 查询banner或者adv【type:1logo，2banner，3special，4adv】
    queryBannerAdv(params, callback) {
      getBannerAdv(params)
        .then((resp) => {
          callback(resp);
        })
        .catch((error) => {
          console.error("Error fetching banner data:", error);
        });
    },
    // 查询商品列表接口
    // queryList() {
    //   getHomeGoods(this.params).then((res) => {
    //     this.loading = false;
    //     if (res.code == 200 && res.data) {
    //       if (res.data.length == 0) {
    //         this.finished = true;
    //       } else {
    //         this.finished = false;
    //         this.list = this.list.concat(res.data);
    //       }
    //     } else {
    //       this.error = true;
    //     }
    //   });
    // },
    // 绘制文字图片
    drawTextCanvas(brand, name) {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const width = (canvas.width = 600);
      const height = (canvas.height = 600);
      // 背景黑色
      ctx.fillStyle = "#000000";
      ctx.fillRect(0, 0, width, height);
      // 文字白色
      ctx.fillStyle = "#ffffff";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      // 文字区域宽度70%
      const textWidth = width * 0.7;
      // 调整字号以适应宽度
      const adjustFontSize = (text, maxWidth) => {
        let fontSize = 48;
        ctx.font = `${fontSize}px Arial`;
        while (ctx.measureText(text).width > maxWidth && fontSize > 12) {
          fontSize -= 2;
          ctx.font = `${fontSize}px Arial`;
        }
        return fontSize;
      };
      // 绘制品牌
      if (brand) {
        const brandFontSize = adjustFontSize(brand, textWidth);
        ctx.font = `${brandFontSize}px Arial`;
        ctx.fillText(brand, width / 2, height / 2 - 30);
      }
      // 绘制商品名称
      if (name) {
        const nameFontSize = adjustFontSize(name, textWidth);
        ctx.font = `${nameFontSize}px Arial`;
        ctx.fillText(name, width / 2, height / 2 + 30);
      }
      return canvas.toDataURL("image/png");
    },
    queryList() {
      getGoods(this.params).then((res) => {
        this.loading = false;
        this.finished = true;
        if (res.code == 200 && res.data) {
          this.list = res.data.records ?? [];
          if (this.list.length == 0) return;
          this.list.forEach((item) => {
            // item.tags = "新品，热销，爆款";
            if (item.tags) {
              item.handleTags = item.tags
                .replace(/，/g, ",")
                .split(",")
                .filter((item) => item.trim() !== "");
              // 步骤1：替换中文逗号为英文逗号 → 步骤2：按英文逗号拆分 → 步骤3：过滤空字符串（避免首尾逗号问题）
            } else {
              item.handleTags = [];
            }
            // 如果没有图片，生成文字图片
            if (!item.goodsImage || item.goodsImage === "") {
              item.goodsImage = this.drawTextCanvas(
                item.goodsBrand || "",
                // 无料号
                item.goodsNum || this.$t("pcHome.noPartNumber"),
              );
            }
          });
        }
      });
    },
    //页面加载
    onLoad() {
      this.loading = false;
      // 模拟更新数据
      if (this.checkMore) {
        this.loading = true;
        // 如果有新数据
        setTimeout(() => {
          this.queryList();
        }, 300);
      } else {
        // 如果没有新数据
        this.finished = true;
      }
    },
    // onLoad() {
    //   this.loading = true;
    //   this.params.pageNum = this.params.pageNum + 1;
    //   this.queryList();
    // },

    // tabs分类
    // supeActive() {
    //   if (this.active == 0) {
    //     this.params.goodsType = 1;
    //   }
    //   if (this.active == 1) {
    //     this.params.goodsType = 2;
    //   }
    // },
    onTab(index) {
      this.active = index;
      this.params.pageNum = 1;
      this.serachShow = true;
      // this.supeActive();
      this.queryList();
    },
    // onTab(index) {
    //   this.active = index;
    //   this.serachShow = true;
    //   this.supeActive();
    //   this.onLoad();
    // },
    // 获取信息列表数据
    async getInfoList(isLoadMore = false) {
      // 只有谈判人角色才请求信息列表
      if (this.userBusinessType == 10) {
        if (!isLoadMore) {
          this.infoLoading = true;
          this.infoError = false;
          this.infoFinished = false;
        }
        try {
          const response = await getHomeClue(this.infoFilters);
          // console.log('接口返回数据:', response);
          if (response.code === 200) {
            // 处理接口返回的数据，确保字段名正确
            const processedData = response.rows.map((item) => {
              if (item.supplierId == 1) this.isAudit = true;
              // console.log('原始数据项:', item);
              // 格式化时间
              let formattedCreateTime = "";
              if (item.createTime) {
                const date = new Date(item.createTime);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                formattedCreateTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
              }
              return {
                id: item.id || item.clueId || "",
                partNumber: item.partNumber || "",
                goodsBrand: item.goodsBrand || "",
                productType: item.productType || "",
                capacity: item.capacity || "",
                architecture: item.architecture || "",
                speed: item.speed || "",
                ball: item.ball || "",
                price:
                  item.goodsPrice !== null && item.goodsPrice !== undefined
                    ? `${item.goodsPrice}${
                        item.goodsPriceUnit === 0
                          ? "CNY"
                          : item.goodsPriceUnit === 10
                            ? "USD"
                            : ""
                      }`
                    : "",
                goodsQuantity: item.goodsQuantity || "",
                manufactureDate: item.manufactureDate || "",
                deliveryAddress: item.deliveryAddress || "",
                usageScenario: item.usageScenario || "",
                supplierName: item.supplierName || "",
                supplierId: item.supplierId || "",
                selected: false,
                createTime: formattedCreateTime,
              };
            });
            // console.log('处理后的数据:', processedData);
            if (isLoadMore) {
              this.infoList = this.infoList.concat(processedData);
            } else {
              this.infoList = processedData;
            }
            // 判断是否还有更多数据
            if (processedData.length < this.infoFilters.pageSize) {
              this.infoFinished = true;
            }
          } else {
            this.infoError = true;
          }
        } catch (error) {
          console.error("获取信息列表失败:", error);
          this.infoError = true;
        } finally {
          this.infoLoading = false;
        }
      }
    },
    // 加载更多信息
    loadMoreInfo() {
      if (this.infoFinished) return;
      this.infoLoading = true;
      setTimeout(() => {
        this.infoFilters.pageNum += 1;
        this.getInfoList(true);
      }, 2500);
    },
    // 处理文件上传
    async handleFileUpload(file) {
      file.status = "uploading";
      // 上传中...
      file.message = this.$t("pcHome.uploading");
      const formData = new FormData();
      formData.append("file", file.file);
      try {
        const resp = await updateFile(formData);
        if (resp.code == 200) {
          file.status = "success";
          // 上传成功
          file.message = this.$t("pcHome.uploadSuccess");
          file.url = resp.url;
        } else {
          // 上传失败
          Message({ message: this.$t("pcHome.uploadFailed"), type: "error" });
          file.status = "failed";
          // 上传失败
          file.message = this.$t("pcHome.uploadFailed");
        }
      } catch (err) {
        // 上传失败
        Message({ message: this.$t("pcHome.uploadFailed"), type: "error" });
        file.status = "failed";
        // 上传失败
        file.message = this.$t("pcHome.uploadFailed");
      }
    },
    // 删除文件
    beforeDeleteFile() {
      return true;
    },
    // 提交导入
    submitImport() {
      if (this.importFileList.length === 0) {
        // 请选择要上传的文件
        Message.warning(this.$t("pcHome.chooseFileFirst"));
        return;
      }

      const fileItem = this.importFileList[0];
      if (fileItem.status !== "success") {
        // 文件上传中，请等待上传完成
        Message.warning(this.$t("pcHome.waitForUpload"));
        return;
      }

      const formData = new FormData();
      formData.append("file", fileItem.file);

      importClue(formData).then((res) => {
        if (res.code == 200) {
          // 导入成功
          Toast.success(this.$t("pcHome.importSuccess"));
          this.showImportDialog = false;
          this.importFileList = [];
          // 重新加载信息列表
          this.getInfoList();
        } else {
          // 导入失败
          Toast.error(res.msg || this.$t("pcHome.importFailed"));
        }
      });
    },
    // 处理取消操作
    handleCancel() {
      this.showImportDialog = false;
      this.importFileList = [];
    },
    // 处理信息列表项选择
    handleCustomSelect(row) {
      if (row.selected) {
        // Add to selected items
        this.selectedInfoItems.push(row);
      } else {
        // Remove from selected items
        this.selectedInfoItems = this.selectedInfoItems.filter(
          (item) => item.id !== row.id,
        );
      }
    },
    // 处理删除选中项
    handleDeleteSelected() {
      // 获取选中项的ids
      const ids = this.selectedInfoItems.map((item) => item.id);
      if (ids.length === 0) return;

      // 二次确认
      Dialog.confirm({
        // 删除确认
        title: this.$t("pcHome.deleteConfirmTitle"),
        // 是否删除这{count}条数据？
        message: this.$t("pcHome.deleteConfirmMessage", {
          count: this.selectedInfoItems.length,
        }),
        // 确定
        confirmButtonText: this.$t("pcHome.confirm"),
        // 取消
        cancelButtonText: this.$t("pcHome.cancel"),
      })
        .then(() => {
          // 调用删除接口
          deleteClue({ ids })
            .then((resp) => {
              if (resp.code === 200) {
                // 删除成功
                Toast.success(this.$t("pcHome.deleteSuccess"));
                // 重置所有选中状态
                this.infoList.forEach((item) => {
                  item.selected = false;
                });
                this.selectedInfoItems = [];
                // 重新加载信息列表
                this.getInfoList();
              }
            })
            .catch((error) => {
              console.error("删除失败:", error);
              // 删除失败，请稍后重试
              Toast.fail(this.$t("pcHome.deleteFailed"));
            });
        })
        .catch(() => {
          // 取消删除
        });
    },
    // 处理审核选中项
    handleAuditSelected() {
      // 获取选中项的ids
      const ids = this.selectedInfoItems.map((item) => item.id);
      if (ids.length === 0) return;

      // 二次确认
      Dialog.confirm({
        // 审核确认
        title: this.$t("pcHome.reviewConfirmTitle"),
        // 是否审核这{count}条数据？
        message: this.$t("pcHome.reviewConfirmMessage", {
          count: this.selectedInfoItems.length,
        }),
        // 确定
        confirmButtonText: this.$t("pcHome.confirm"),
        // 取消
        cancelButtonText: this.$t("pcHome.cancel"),
      })
        .then(() => {
          // 调用审核接口
          auditClue({ ids }).then((resp) => {
            if (resp.code === 200) {
              // 审核成功
              Message.success(this.$t("pcHome.reviewSuccess"));
              // 重置所有选中状态
              this.infoList.forEach((item) => {
                item.selected = false;
              });
              this.selectedInfoItems = [];
              // 重新加载信息列表
              this.getInfoList();
              this.queryList();
            }
          });
        })
        .catch(() => {
          // 取消审核
        });
    },
  },
  async created() {
    // 登录状态判断
    const hasTiped = sessionStorage.getItem("hasTip");
    if (!hasTiped) {
      if (this.isLogin()) {
        this.getUserInfoDetail();
      }
    }

    this.queryBannerAdv(
      { which: 1, type: 1, position: "HOME", status: 0 },
      (res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          this.logoList = res.data.sort((a, b) => a.sort - b.sort);
        }
      },
    );
    this.queryBannerAdv(
      { which: 1, type: 2, position: "HOME", status: 0 },
      (res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          this.bannerList = res.data;
        }
      },
    );
    this.queryBannerAdv(
      { which: 1, type: 4, position: "HOME", status: 0 },
      (res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          this.advImg = res.data[0].image;
        }
      },
    );
    // 加载商品列表
    this.onLoad();
    getHomeNav({
      pageId: 0,
      which: 1,
      position: "HOME",
      status: 0,
    }).then((resp) => {
      this.navList = resp.data;
    });
    // 检查用户登录状态，获取用户信息
    if (this.isLogin()) {
      this.getUserInfoDetail();
    }
    // const {
    //   data: { pageData },
    // } = await getHomeData();
    // this.bannerList = pageData.items[1].data;
    // this.navList = pageData.items[3].data;
    // this.proList = pageData.items[6].data;
    // console.log(this.bannerList);
  },
};
</script>

<style lang="less" scoped>
.home {
  // 重要：设置高度使容器可滚动
  width: 100%;
  height: 100vh;
  overflow: scroll;
}

// 导航条样式定制
.home-bg {
  height: var(--custom-bg-height); /* 使用自定义高度变量 */
  z-index: -1;
  width: 100%;
}

// 下列内容的整体容器
.main-container {
  width: @pc-container-width;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

.shortcut-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}

/* 滚动按钮样式 */
.scroll-btn {
  width: 35px;
  height: 35px;
  border: 1px solid #eee;
  border-radius: 50%;
  background: rgba(61, 61, 61, 0.2);
  color: #fff;
  font-size: 24px;
  line-height: 35px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.scroll-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.left-btn {
  left: -47px;
}

.right-btn {
  right: -47px;
}

/* 滚动容器 */
.scroll-container {
  // flex: 1;
  overflow: hidden; /* 隐藏默认滚动条 */
  // position: relative;
  // width: ;
}

.grid-outer {
  overflow: hidden; /* 限制内容显示范围 */
}

.grid-title {
  margin-bottom: 42px;
  font-size: 28px;
  font-weight: 700;
  color: #3b3b3b;
}
//种类导航
.grid-container {
  display: flex;
  gap: 24px;
  width: 100%;
  /* 核心：延长过渡时间并使用平滑曲线 */
  transition: transform 0.4s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.grid-item {
  background-color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: @br12;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 41px 0px;
  width: 170px;
  flex-shrink: 0; // 防止被 flex 布局压缩
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  // border-radius: @br12;
  // background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  overflow: hidden;
}

.grid-item:hover .icon-wrapper {
  transform: scale(1.05);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.grid-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.grid-text {
  font-size: 18px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
}
// 轮播图部分
.my-swipe {
  border-radius: @br12;
  .van-swipe-item {
    height: 185px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    background-color: #39a9ed;
    img {
      width: 100%;
      height: 185px;
    }
  }
}

// 主会场

.main {
  height: 120px;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  img {
    display: block;
    width: 100%;
  }
}

// 猜你喜欢
.guess .guess-title {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #ffffff;
}

// 标签页样式
.tab-container {
  margin-top: 40px;
  margin-bottom: 80px;
}

.tab-header {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-item {
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  margin-right: 40px;
  position: relative;
  color: #333;
  transition: all 0.3s ease;

  &:hover {
    color: #4689f2;
  }

  &.active {
    color: #4689f2;
    font-weight: 600;

    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;
      height: 2px;
      background-color: #4689f2;
    }
  }
}

.tab-content {
  padding: 20px 0;
}

// 商品列表样式
.goods-list-pc {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

// Element UI 表格样式覆盖
:deep(.el-table) {
  margin-top: 20px;

  .el-table__header-wrapper th {
    background-color: #f5f7fa;
    font-weight: 600;
  }

  .el-table__row:nth-child(even) {
    background-color: #fafafa;
  }

  .el-table__row:hover {
    background-color: #f0f9eb;
  }
}

// 加载和错误状态样式
.loading-container,
.error-container {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}
</style>
